<template>
  <div class="news-post scroll">
    <div class="body-post">
      <NewsPageBodyPostHeader
        :is-show-full-news="isShowFullNews"
        @toggle-show-full-news="toggleShowFullNews"
      />
      <NewsPageBodyPostBody />
      <NewsPageBodyPostFooter :is-show-full-news="isShowFullNews" />
    </div>
    <!-- Полноэкранное отображение новости -->
    <NewsPageFullView
      v-if="isShowFullNews"
      :is-show-full-news="isShowFullNews"
      @toggle-show-full-news="toggleShowFullNews"
    />
  </div>
</template>
<script setup>
import NewsPageBodyPostHeader from "./NewsPageBodyPost/NewsPageBodyPostHeader.vue";
import NewsPageBodyPostBody from "@/components/NewsPage/NewsPageBody/NewsPageBodyPost/NewsPageBodyPostBody.vue";
import NewsPageBodyPostFooter from "@/components/NewsPage/NewsPageBody/NewsPageBodyPost/NewsPageBodyPostFooter.vue";
import {ref, onUnmounted, defineEmits} from "vue";
import NewsPageFullView from "@/components/NewsPage/NewsPageBody/NewsPageFullView.vue";

const emit = defineEmits(["update:is-show-full-news"]);

// Флаг. Полноэкранное отображение новости
const isShowFullNews = ref(false);

// Функция. Переключение полноэкранного отображения новости
const toggleShowFullNews = () => {
  isShowFullNews.value = !isShowFullNews.value;
  document.body.style.overflow = isShowFullNews.value ? "hidden" : "";
  emit("update:is-show-full-news", isShowFullNews.value);
};

onUnmounted(() => {
  document.body.style.overflow = "";
  emit("update:is-show-full-news", false);
});

</script>

<style lang="scss" scoped>

.news-post {
  padding: 0 5px 14px 0;
}

.body-post {
  display: flex;
  flex-direction: column;
  padding: 0 30px 30px;
  background-color: var(--background-bg-white);
  border-radius: 10px;
}
</style>
